(() => {
    const root = document.querySelector('[data-compare-page-root]');
    if (!root || root.dataset.comparePageBound === 'true') return;
    root.dataset.comparePageBound = 'true';

    const STORAGE_KEY = 'db-rug-comparison-shopify-v1';
    const PREFS_KEY = 'db-rug-comparison-page-v1';
    const body = root.querySelector('[data-compare-page-body]');
    const notes = root.querySelector('[data-compare-page-notes]');
    const sizeDialog = root.querySelector('[data-compare-size-dialog]');
    const changeDialog = root.querySelector('[data-compare-change-dialog]');
    const sizeList = root.querySelector('[data-compare-size-list]');
    const pickList = root.querySelector('[data-compare-pick-list]');
    const closeIcon = (root.querySelector('[data-compare-icon-close]') || {}).innerHTML || '';
    const arrowIcon = (root.querySelector('[data-compare-icon-arrow]') || {}).innerHTML || '';
    const HEX = {
      'Laine Naturelle': '#F4EFE4',
      'Gris Cendré': '#A8A29A',
      'Marron Terre': '#6B4423',
      Beige: '#D4C4A8',
      'Brun Noisette': '#8B6914',
      'Soleil Doré': '#C9A83C',
      'Rose Doux': '#D4846A',
      Terracotta: '#C45C28',
      'Rouge Intense': '#8B2020',
      'Bleu Océan': '#4A7A9B',
      'Vert Patiné': '#6E7458',
      'Vert Militaire': '#4A5C3A',
      'Bleu Royal': '#3A5090',
      'Bleu Profond': '#2A3050',
      'Noir Royal': '#1A1410',
      'Natural wool': '#F4EFE4',
      'Ash gray': '#A8A29A',
      Brown: '#6B4423',
      'Hazel Brown': '#8B6914',
      Sunlight: '#C9A83C',
      Rose: '#D4846A',
      'Deep Red': '#8B2020',
      Patina: '#6E7458',
      'Hawaiian Blue': '#4A7A9B',
      'Soldier Green': '#4A5C3A',
      'Royal Blue': '#3A5090',
      'Navy Blue': '#2A3050',
      'Black King': '#1A1410',
      Écru: '#F4EFE4',
      Ecru: '#F4EFE4',
      Encre: '#1A1410'
    };

    const readJson = (selector, fallback) => {
      const node = root.querySelector(selector);
      if (!node) return fallback;
      try {
        return JSON.parse(node.textContent || '');
      } catch (error) {
        return fallback;
      }
    };

    const i18n = readJson('[data-compare-page-i18n]', {});
    const config = readJson('[data-compare-page-config]', {});
    const catalog = readJson('[data-compare-catalog]', []);
    const rugsUrl = config.rugsUrl || '/collections/tapis-berbere';
    const piles = Array.isArray(config.piles) && config.piles.length ? config.piles : ['3 cm', '1,5 cm'];
    let changeIndex = 0;

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const fill = (template, key, value) => String(template || '').split(`[[${key}]]`).join(value || '');

    const normalizeSize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/×|✕/g, 'x')
        .replace(/cm/g, '')
        .replace(/\s+/g, '');

    const catalogByHandle = new Map((catalog || []).map((item) => [item.handle, item]));

    const formatMoney = (cents) => {
      const amount = Math.round(Number(cents || 0) / 100);
      const formatted = String(amount);
      const pattern = config.moneyFormat;
      if (!pattern) return formatted + ' €';
      return String(pattern)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount\s*\}\}/g, formatted);
    };

    const parseSizeParts = (label) => {
      const id = normalizeSize(label);
      const parts = id.split('x').map((part) => Number(part) || 0);
      return { id, width: parts[0] || 0, length: parts[1] || 0, label };
    };

    const prettySize = (label) => {
      const parsed = parseSizeParts(label);
      if (parsed.width && parsed.length) return parsed.width + ' × ' + parsed.length + ' cm';
      return label || '';
    };

    const readPrefs = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(PREFS_KEY) || 'null');
        if (!parsed || typeof parsed !== 'object') return { size: config.defaultSize || '', piles: {} };
        return {
          size: String(parsed.size || config.defaultSize || ''),
          piles: parsed.piles && typeof parsed.piles === 'object' ? parsed.piles : {}
        };
      } catch (error) {
        return { size: config.defaultSize || '', piles: {} };
      }
    };

    const writePrefs = (prefs) => {
      try {
        localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
      } catch (error) {}
    };

    const readState = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (!parsed || !Array.isArray(parsed.products)) return { products: [] };
        return { products: parsed.products.filter((item) => item && item.handle).slice(0, 2) };
      } catch (error) {
        return { products: [] };
      }
    };

    const enrich = (item) => {
      const entry = catalogByHandle.get(item.handle) || {};
      return {
        handle: item.handle,
        title: entry.title || item.title || item.handle,
        url: entry.url || item.url || `/products/${item.handle}`,
        image: entry.image || item.image || '',
        family: entry.family || item.family || '',
        material: entry.material || '',
        feel: entry.feel || '',
        making: entry.making || '',
        hasPile: entry.handle ? entry.hasPile !== false : true,
        weeks: entry.weeks || 12,
        sampleUrl: entry.sampleUrl || config.sampleUrl || '',
        samplePrice: entry.samplePrice || '',
        colors: entry.colors && typeof entry.colors === 'string' ? null : entry.colors || null,
        sizes: Array.isArray(entry.sizes) ? entry.sizes : [],
        refPriceCents: Number(entry.refPriceCents) || 0,
        refArea: Number(entry.refArea) || 0
      };
    };

    const priceFor = (product, size) => {
      const match = product.sizes.find((entry) => entry.id === size.id);
      if (match) return match;
      if (product.refPriceCents && product.refArea && size.width && size.length) {
        const cents = Math.round(product.refPriceCents * ((size.width * size.length) / product.refArea));
        return { price: formatMoney(cents), cents, url: product.url, label: size.label };
      }
      if (product.sizes[0]) return product.sizes[0];
      return { price: '', cents: 0, url: product.url, label: size.label };
    };

    const hexOf = (name, colors) => {
      const color = (colors || []).find((item) => item.name === name);
      return (color && color.hex) || HEX[name] || '#F4EFE4';
    };

    const chosenColours = (product) => {
      const colors = product.colors;
      if (!colors || !Array.isArray(colors.colors) || !colors.colors.length) return [];
      const defaults = colors.defaults || {};
      const mode = colors.mode === 'single' ? 'single' : 'dual';
      if (mode === 'single') {
        const name = defaults.single || colors.colors[0].name;
        return [
          {
            label: colors.woolCardLabel || i18n.colourMain,
            name,
            hex: hexOf(name, colors.colors)
          }
        ];
      }
      const ground = defaults.ground || (colors.colors.find((item) => item.slot === 'ground') || {}).name || '';
      const pattern = defaults.pattern || (colors.colors.find((item) => item.slot === 'pattern') || {}).name || '';
      const rows = [];
      if (ground) {
        rows.push({
          label: colors.groundLabel || colors.woolCardLabel || i18n.colourGround,
          name: ground,
          hex: hexOf(ground, colors.colors)
        });
      }
      if (pattern) {
        rows.push({
          label: colors.patternLabel || i18n.colourPattern,
          name: pattern,
          hex: hexOf(pattern, colors.colors)
        });
      }
      return rows;
    };

    const sharedSize = (products, prefs) => {
      const preferred = parseSizeParts(prefs.size || config.defaultSize || '');
      const allSizes = [];
      products.forEach((product) => {
        product.sizes.forEach((entry) => {
          if (!allSizes.some((item) => item.id === entry.id)) allSizes.push(entry);
        });
      });
      if (preferred.id && (products.length === 0 || products.some((product) => product.sizes.some((entry) => entry.id === preferred.id) || product.refArea))) {
        const known = allSizes.find((entry) => entry.id === preferred.id);
        return known ? { ...known } : { ...preferred, label: prefs.size || config.defaultSize };
      }
      if (allSizes.length) return allSizes[0];
      return preferred;
    };

    const emptyHtml = () => {
      const link = rugsUrl
        ? `<a class="compare-page__text-link" href="${escapeHtml(rugsUrl)}">${escapeHtml(i18n.addModel)}${arrowIcon}</a>`
        : '';
      return `<div class="compare-empty"><h2>${escapeHtml(i18n.emptyTitle)}</h2><p>${escapeHtml(i18n.emptyBody)}</p>${link}</div>`;
    };

    const productCell = (product, index, size, prefs) => {
      const title = escapeHtml(product.title);
      const image = product.image
        ? `<a class="compare-board__photo" href="${escapeHtml(product.url)}"><img src="${escapeHtml(product.image)}" alt="${title}" width="400" height="500"></a>`
        : `<a class="compare-board__photo" href="${escapeHtml(product.url)}"></a>`;
      return `<div class="compare-board__cell">
        <div class="compare-board__actions">
          <button type="button" data-compare-change="${index}">${escapeHtml(i18n.change)}</button>
          <button type="button" data-compare-remove="${escapeHtml(product.handle)}" aria-label="${escapeHtml(fill(i18n.removeProduct, 'name', product.title))}">${closeIcon}</button>
        </div>
        ${image}
        <p class="compare-board__origin">${escapeHtml(i18n.originalColours)}</p>
        <h3>${title}</h3>
        <p class="compare-board__family">${escapeHtml(product.family)}</p>
      </div>`;
    };

    const addCell = () =>
      `<div class="compare-board__cell"><a class="compare-board__add" href="${escapeHtml(rugsUrl)}">${escapeHtml(i18n.addModel)}</a></div>`;

    const valueCells = (products, renderValue, emptyValue) =>
      [0, 1]
        .map((index) => {
          const product = products[index];
          const content = product ? renderValue(product, index) : emptyValue || `<span>${escapeHtml(i18n.missing)}</span>`;
          return `<div class="compare-board__cell">${content}</div>`;
        })
        .join('');

    const renderBoard = (state) => {
      if (!body) return;
      const products = (state.products || []).map(enrich);
      if (notes) notes.hidden = products.length === 0;
      if (!products.length) {
        body.innerHTML = emptyHtml();
        return;
      }

      const prefs = readPrefs();
      const size = sharedSize(products, prefs);
      const sizeLabel = prettySize(size.label || config.defaultSize || '');

      const head = products.map((product, index) => productCell(product, index, size, prefs)).join('');
      const add = products.length === 1 ? addCell() : '';

      body.innerHTML = `<div class="compare-board">
        <div class="compare-board__span compare-board__size">
          <p><span>${escapeHtml(i18n.sharedSize)}</span><strong>${escapeHtml(sizeLabel)}</strong></p>
          <button type="button" data-compare-size-open>${escapeHtml(i18n.modify)}</button>
        </div>
        ${head}${add}
        <div class="compare-board__label">${escapeHtml(fill(i18n.priceFor, 'size', sizeLabel))}</div>
        ${valueCells(products, (product) => {
          const priced = priceFor(product, size);
          return `<strong class="compare-board__price">${escapeHtml(priced.price)}</strong><p class="compare-board__hint">${escapeHtml(i18n.shipping)}</p>`;
        })}
        <div class="compare-board__label">${escapeHtml(i18n.coloursChosen)}</div>
        ${valueCells(products, (product) => {
          const rows = chosenColours(product);
          if (!rows.length) return `<p>${escapeHtml(i18n.originalColours)}</p>`;
          return `<div class="compare-board__swatches">${rows
            .map(
              (row) =>
                `<p class="compare-board__swatch"><i style="background-color:${escapeHtml(row.hex)}"></i><span>${escapeHtml(row.label)} : ${escapeHtml(row.name)}</span></p>`
            )
            .join('')}</div>`;
        })}
        <div class="compare-board__label">${escapeHtml(i18n.material)}</div>
        ${valueCells(products, (product) => escapeHtml(product.material))}
        <div class="compare-board__label">${escapeHtml(i18n.feelWeaving)}</div>
        ${valueCells(products, (product) => {
          const feel = product.feel ? `<p class="compare-board__feel">${escapeHtml(product.feel)}</p>` : '';
          const making = product.making ? `<p class="compare-board__making">${escapeHtml(product.making)}</p>` : '';
          return `${feel}${making}`;
        })}
        <div class="compare-board__label">${escapeHtml(i18n.thickness)}</div>
        ${valueCells(products, (product) => {
          if (!product.hasPile) {
            return product.making ? `<p>${escapeHtml(product.making)}</p>` : `<p>—</p>`;
          }
          const selected = prefs.piles[product.handle] || piles[0];
          const buttons = piles
            .map(
              (pile) =>
                `<button type="button" class="compare-board__pile" data-compare-pile="${escapeHtml(product.handle)}" data-pile-value="${escapeHtml(pile)}" aria-pressed="${pile === selected ? 'true' : 'false'}">${escapeHtml(pile)}</button>`
            )
            .join('');
          return `<div class="compare-board__piles">${buttons}</div><p class="compare-board__hint">${escapeHtml(i18n.pileNote)}</p>`;
        })}
        <div class="compare-board__label">${escapeHtml(i18n.reception)}</div>
        ${valueCells(products, (product) => {
          const priced = priceFor(product, size);
          const href = priced.url || product.url;
          return `<p class="compare-board__reception">${escapeHtml(fill(i18n.receptionValue, 'weeks', String(product.weeks)))}</p>
            <p class="compare-board__hint">${escapeHtml(i18n.receptionNote)}</p>
            <a class="compare-board__cta" href="${escapeHtml(href)}">${escapeHtml(fill(i18n.choose, 'name', product.title))}${arrowIcon}</a>
            <a class="compare-board__sample" href="${escapeHtml(product.sampleUrl || '#')}">${escapeHtml(i18n.sample)}</a>
            <p class="compare-board__hint">${escapeHtml(fill(i18n.sampleNote, 'price', product.samplePrice))}</p>`;
        })}
      </div>`;
    };

    const openDialog = (dialog) => {
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    };

    const closeDialog = (dialog) => {
      if (dialog && dialog.open) dialog.close();
    };

    const uniqueSizes = (products) => {
      const sizes = [];
      const source = products.length ? products : catalog;
      source.forEach((product) => {
        (product.sizes || []).forEach((entry) => {
          if (!sizes.some((item) => item.id === entry.id)) sizes.push(entry);
        });
      });
      const preferred = parseSizeParts(config.defaultSize || '');
      if (preferred.id && !sizes.some((item) => item.id === preferred.id)) {
        sizes.push({ id: preferred.id, label: config.defaultSize, width: preferred.width, length: preferred.length });
      }
      sizes.sort((a, b) => {
        const [aw, ah] = a.id.split('x').map(Number);
        const [bw, bh] = b.id.split('x').map(Number);
        return (aw || 0) - (bw || 0) || (ah || 0) - (bh || 0);
      });
      return sizes;
    };

    const openSizeDialog = () => {
      const products = readState().products.map(enrich);
      const prefs = readPrefs();
      const current = sharedSize(products, prefs);
      if (!sizeList) return;
      sizeList.innerHTML = uniqueSizes(products)
        .map(
          (entry) =>
            `<button type="button" data-compare-size-option="${escapeHtml(prettySize(entry.label))}" aria-pressed="${entry.id === current.id ? 'true' : 'false'}">${escapeHtml(prettySize(entry.label))}</button>`
        )
        .join('');
      openDialog(sizeDialog);
    };

    const openChangeDialog = (index) => {
      changeIndex = index;
      const selected = new Set(readState().products.map((item) => item.handle));
      if (!pickList) return;
      pickList.innerHTML = catalog
        .filter((item) => !selected.has(item.handle))
        .map((item) => {
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="" width="200" height="160">`
            : '';
          return `<button type="button" data-compare-pick="${escapeHtml(item.handle)}">${image}<strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.family)}</span></button>`;
        })
        .join('');
      openDialog(changeDialog);
    };

    const pickProduct = (handle) => {
      const entry = catalogByHandle.get(handle);
      if (!entry || typeof window.dbCompareReplaceSlot !== 'function') return;
      window.dbCompareReplaceSlot(changeIndex, {
        handle: entry.handle,
        title: entry.title,
        url: entry.url,
        image: entry.image,
        family: entry.family,
        price: entry.sizes[0] ? entry.sizes[0].price : '',
        size: entry.sizes[0] ? entry.sizes[0].label : ''
      });
      closeDialog(changeDialog);
    };

    root.addEventListener('click', (event) => {
      const closer = event.target.closest('[data-compare-dialog-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }
      if (event.target.closest('[data-compare-size-open]')) {
        event.preventDefault();
        openSizeDialog();
        return;
      }
      const sizeOption = event.target.closest('[data-compare-size-option]');
      if (sizeOption) {
        const prefs = readPrefs();
        prefs.size = sizeOption.getAttribute('data-compare-size-option') || prefs.size;
        writePrefs(prefs);
        closeDialog(sizeDialog);
        renderBoard(readState());
        return;
      }
      const changer = event.target.closest('[data-compare-change]');
      if (changer) {
        event.preventDefault();
        openChangeDialog(Number(changer.getAttribute('data-compare-change') || 0));
        return;
      }
      const pick = event.target.closest('[data-compare-pick]');
      if (pick) {
        event.preventDefault();
        pickProduct(pick.getAttribute('data-compare-pick'));
        return;
      }
      const pile = event.target.closest('[data-compare-pile]');
      if (pile) {
        const prefs = readPrefs();
        prefs.piles[pile.getAttribute('data-compare-pile')] = pile.getAttribute('data-pile-value') || piles[0];
        writePrefs(prefs);
        renderBoard(readState());
      }
    });

    [sizeDialog, changeDialog].forEach((dialog) => {
      if (!dialog) return;
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });
    });

    window.dbRenderComparePage = (state) => renderWithMissing(state);

    // The preloaded catalog stops at 50 products, so rugs outside it are
    // fetched one by one through the product.compare-entry template.
    const productRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

    const fetchEntry = (handle) =>
      fetch(`${productRoot}products/${encodeURIComponent(handle)}?view=compare-entry`, {
        headers: { Accept: 'application/json' }
      })
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const entry = JSON.parse(text);
          if (entry && entry.handle) catalogByHandle.set(handle, entry);
        })
        .catch(() => {});

    const loadMissing = (handles) =>
      Promise.all(handles.filter((handle) => handle && !catalogByHandle.has(handle)).map(fetchEntry));

    const renderWithMissing = (state) => {
      renderBoard(state);
      const missing = (state.products || []).map((item) => item.handle).filter((handle) => !catalogByHandle.has(handle));
      if (missing.length) loadMissing(missing).then(() => renderBoard(readState()));
    };

    const params = new URLSearchParams(window.location.search);
    const seedHandles = (params.get('tapis') || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .slice(0, 2);

    const seedFromParams = () => {
      const seeded = seedHandles
        .map((handle) => catalogByHandle.get(handle))
        .filter(Boolean)
        .map((entry) => ({
          handle: entry.handle,
          title: entry.title,
          url: entry.url,
          image: entry.image,
          family: entry.family,
          price: entry.sizes[0] ? entry.sizes[0].price : '',
          size: entry.sizes[0] ? entry.sizes[0].label : ''
        }));
      if (seeded.length) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({ products: seeded }));
        } catch (error) {}
      }
    };

    if (seedHandles.some((handle) => !catalogByHandle.has(handle))) {
      renderBoard(readState());
      loadMissing(seedHandles).then(() => {
        seedFromParams();
        renderWithMissing(readState());
      });
    } else {
      seedFromParams();
      renderWithMissing(readState());
    }
  })();
